import Col from 'antd/lib/col';
import styled, { DefaultTheme, StyledComponent } from 'styled-components';

export const VerticalDivider: StyledComponent<typeof Col, DefaultTheme> = styled(Col)`
  align-self: stretch;
  background-color: ${({ theme }) => theme.colors.lightGrey1};
  margin: 0 20px;
  width: 1px;
`;
